"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mega Matcher ID management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2024.2.0
 * Contact: support@neurotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JanusResponseJanus = void 0;
exports.JanusResponseJanus = {
    Create: 'CREATE',
    Message: 'MESSAGE',
    Attach: 'ATTACH',
    Destroy: 'DESTROY',
    Trickle: 'TRICKLE',
    Error: 'ERROR',
    ServerInfo: 'SERVER_INFO',
    Success: 'SUCCESS',
    Ack: 'ACK',
    Event: 'EVENT',
    Info: 'INFO',
    Keepalive: 'KEEPALIVE',
    Hangup: 'HANGUP',
    Webrtcup: 'WEBRTCUP',
    ListSessions: 'LIST_SESSIONS',
    ListHandles: 'LIST_HANDLES',
    HandleInfo: 'HANDLE_INFO',
    GetStatus: 'GET_STATUS',
    SetSessionTimeout: 'SET_SESSION_TIMEOUT',
    SetLogLevel: 'SET_LOG_LEVEL',
    SetLogTimestamps: 'SET_LOG_TIMESTAMPS',
    SetLogColors: 'SET_LOG_COLORS',
    SetLockingDebug: 'SET_LOCKING_DEBUG',
    SetRefcountDebug: 'SET_REFCOUNT_DEBUG',
    SetLibniceDebug: 'SET_LIBNICE_DEBUG',
    SetNoMediaTimer: 'SET_NO_MEDIA_TIMER'
};
